import React from "react";
import BannerNotificationAlerts from "Common/BannerNotificationAlerts/index.js";
import { useFlags } from "launchdarkly-react-client-sdk";


export default function TechnicalDifficultyBanner({ currentMarket }) {
    const { technicalDifficultyBanner } = useFlags();
    return (
        <BannerNotificationAlerts
            currentMarket={currentMarket}
            rosettaAlterations={displayMessage => displayMessage}
            bannerFlagLD={technicalDifficultyBanner}
            flagNameLD="technicalDifficultyBanner"
        />
    );
}



// WEBPACK FOOTER //
// ./src/components/StartContainer/TechnicalDifficultyBanner/index.js